import { useEffect, useState } from 'react';
import { useSessionStorage } from 'Utilities/UseStorage';
import MegaMenu from './MegaMenu';
import './MainNavigation.scss';
import { GetLMMainNavigation } from './NowNavigationAPI';
import { CoveoStandaloneSearchBoxSlideout } from 'Feature/Coveo/CoveoStandaloneSearchBoxSlideout';
import QuoteModal from 'Feature/Quoting/QuoteModal';
import { isPL } from 'Foundation/Configurations/GlobalConfiguration';
import { FloatingHeader, HeaderAppName, HeaderMenuButton, HeaderNavigation, HeaderParentItem } from '@lmig/lmds-react-floating-header';

const compVersion = 'v1';

export function LMMainNavigation() {
  const expirationMinutes: number = 8 * 60;
  const getSiteToken = 'LMMainNavData-' + compVersion + window.location.href.split('/')[2];
  const [megaMenus, setMegaMenus] = useSessionStorage<IReactMegaMenu[]>(getSiteToken, undefined, expirationMinutes);
  const [isSearchOpen, setIsSearchOpen] = useState<boolean>(false);

  useEffect(() => {
    let isMounted = true;

    const getMainNavData = async () => {
      try {
        let menus = await GetLMMainNavigation();
        if (menus && menus.length > 0) {
          if (isMounted) setMegaMenus({ data: menus });
        }
        // Body is hidden by default and waits for menu to load to help with jarring transitions when page loads
        document.body.classList.add('force-show-body');
      } catch (ex) {}
    };

    if (!megaMenus) {
      getMainNavData();
    } else {
      // Body is hidden by default and waits for menu to load to help with jarring transitions when page loads
      document.body.classList.add('force-show-body');
    }

    return () => {
      isMounted = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getSiteToken, megaMenus]);

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleScroll = () => {
    var offset = (100 - window.scrollY).toFixed(0).toString() + 'px';
    var menus = document.querySelectorAll('.column-count-4, .column-count-3') as NodeListOf<HTMLLinkElement>;
    for (let i = 0; i < menus.length; i++) {
      menus[i].style.top = offset;
    }
  };

  const [isOverlayOpen, setOverlayOpen] = useState(false);

  //below condition checking the url path can be removed once we decommission agent news
  const brand = 'liberty';

  return (
    <>
      <div id="quote-modal-container" />
      <FloatingHeader
        brand={brand}
        overlayIsOpen={isOverlayOpen}
        isFullWidth={true}
        isFullBackground={false}
        className="floating-header"
        brandLinkProps={{ href: '/start' }}
      >
        <HeaderAppName hideDivider={true}>{isPL() ? 'Personal lines' : 'Small commercial'}</HeaderAppName>
        {/*phone/tablet view*/}
        <HeaderNavigation id="header-navigation-main">
          {!(window?.origin?.toLowerCase().includes('news.') || window?.origin?.toLowerCase().includes('public.')) && (
            <div id="quote-search-button-container-mobile">
              <div id="mobile-header-search-container" className="mobile-header">
                <CoveoStandaloneSearchBoxSlideout showSearch={true} />
              </div>
              <QuoteModal />
            </div>
          )}
          {megaMenus && (
            <>
              {megaMenus?.map((menu: IReactMegaMenu) => (
                <HeaderParentItem
                  key={menu.Title}
                  labelVisual={menu.Title}
                  className={isSearchOpen ? 'hidden' : ''}
                >
                  <MegaMenu
                    Id={menu.Title + '_menu'}
                    Columns={menu.Columns}
                    key={menu.Title}
                    Link={menu.Link}
                    Title={menu.Title}
                    Active={menu.Active}
                    RichText={''}
                  ></MegaMenu>
                </HeaderParentItem>
              ))}
            </>
          )}
        </HeaderNavigation>
        <div className="header-actions">
          <div className="search-icon-container">
            <CoveoStandaloneSearchBoxSlideout onOpen={(isOpen: boolean) => setIsSearchOpen(isOpen)} />
          </div>
          {!(window?.origin?.toLowerCase().includes('news.') || window?.origin?.toLowerCase().includes('public.')) && (
            // desktop view
            <div id="quote-button-container">
              <QuoteModal />
            </div>
          )}
        </div>

        {/* hamburger*/}
        <HeaderMenuButton onToggle={() => setOverlayOpen(!isOverlayOpen)} />
      </FloatingHeader>
    </>
  );
}
export default LMMainNavigation;
